import { __ } from '~/locale';
import CrudComponent from '../../vue_shared/components/crud_component.vue?vue3';
import query from '../graphql/issues.query.graphql';
import TitleSuggestionsItem from './title_suggestions_item.vue?vue3';
export default {
    name: 'TitleSuggestions',
    components: {
        TitleSuggestionsItem,
        CrudComponent
    },
    props: {
        projectPath: {
            type: String,
            required: true
        },
        search: {
            type: String,
            required: true
        },
        helpText: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: ''
        }
    },
    apollo: {
        issues: {
            query,
            debounce: 1000,
            skip () {
                return this.isSearchEmpty;
            },
            update: (data)=>data?.project?.issues?.edges.map(({ node })=>node) ?? [],
            variables () {
                return {
                    fullPath: this.projectPath,
                    search: this.search
                };
            }
        }
    },
    data () {
        return {
            issues: [],
            loading: 0
        };
    },
    computed: {
        isSearchEmpty () {
            return !this.search.length;
        },
        showSuggestions () {
            return !this.isSearchEmpty && this.issues.length && !this.loading;
        },
        helpIconTitle () {
            return this.helpText || this.$options.i18n.helpText;
        },
        suggestionsTitle () {
            return this.title || __('Similar issues');
        }
    },
    watch: {
        search () {
            if (this.isSearchEmpty) {
                this.issues = [];
            }
        }
    },
    i18n: {
        helpText: __('These existing issues have a similar title. It might be better to comment there instead of creating another similar issue.')
    }
};
